import { PureComponent } from 'react';

import Tooltip from '@atlaskit/tooltip';

import * as styles from './ref-branch.styled';

type Props = {
  /** The name of the branch. */
  name: string;
  isFluidWidth?: boolean;
  ariaHidden?: boolean;
};

// eslint-disable-next-line import/no-default-export
export default class RefBranch extends PureComponent<Props> {
  render() {
    const { name, isFluidWidth, ariaHidden } = this.props;
    return (
      <Tooltip content={name} position="bottom">
        <styles.BranchText
          isFluidWidth={!!isFluidWidth}
          aria-hidden={ariaHidden ? true : undefined}
        >
          {this.props.name}
        </styles.BranchText>
      </Tooltip>
    );
  }
}
